module.exports = __webpack_public_path__ + "static/img/td.d2ea13f1.svg";